import React, { useEffect, useLayoutEffect, useState } from "react";
import Switch from "@mui/material/Switch";
import { FormControlLabel, Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import DayRipetizioniBox from "./DayRipetizioniBox/DayRipetizioniBox";
import { ControlloRipetizioneStatus, returnRipetizioneDataFine } from "../../../../redux/reducers/prenotazioneStepper-reducer";
import GeneralCustomDateTimePicker from "../../../UI/TimePicker/GeneralCustomDateTimePicker";
import { t } from "i18next";

const nowPiuUno = new Date(new Date().setDate(new Date().getDate() + 1)).toString()

export default function RipetizioniBox({ maxday, minDayValue, isConfiguredCorrectly }) {
  const dispatch = useDispatch();
  const [valueDataFineRipetizioni, setValueDataFineRipetizioni] = useState(nowPiuUno);
  const state = useSelector((state) => state.prenotazioneStepper);
  const { ripetizioneStatus, ripetizioneDataFine, ripetizioneGiorni } = state;
  const minDayDate = new Date(minDayValue);
  
  //se lo stato dello switch cambia, svuota l'array
  useLayoutEffect(() => {
    if(!ripetizioneStatus) {
      setValueDataFineRipetizioni(nowPiuUno)
    }
    isConfiguredCorrectly(!ripetizioneStatus || ripetizioneStatus && ripetizioneGiorni.length > 0 ) 
  }, [ripetizioneStatus, ripetizioneGiorni])

  const handleChangeData = (newValue) => {
    if (newValue !== null) {
      dispatch(returnRipetizioneDataFine(newValue.toString()));
      setValueDataFineRipetizioni(newValue);
    } else {
      dispatch(returnRipetizioneDataFine("null"));
      setValueDataFineRipetizioni("null");
    }
  };

useEffect(() => {
  if(minDayDate) {
    let dateSaved = new Date(valueDataFineRipetizioni)
    let newDate = new Date(minDayDate)
    if(newDate.getTime() > dateSaved.getTime()) {
      setValueDataFineRipetizioni(minDayDate)
      dispatch(returnRipetizioneDataFine(minDayDate.toString()));
    }
  }
}, [minDayDate, ripetizioneStatus])

  useLayoutEffect(() => {
    ripetizioneStatus ? setValueDataFineRipetizioni(ripetizioneDataFine) : setValueDataFineRipetizioni(nowPiuUno);
  }, [ripetizioneStatus])

  return (
    <React.Fragment>
      <Grid container rowSpacing={1} columnSpacing={5}>
        <Grid item xs={12} >
          <FormControlLabel control={
            <Switch
              onChange={() => { dispatch(ControlloRipetizioneStatus(!ripetizioneStatus)) }}
              checked={ripetizioneStatus}
            />
          } label={t("Repeat_booking")} />
        </Grid>
        {ripetizioneStatus && <><Grid item xs={12} sm={6} md={4} lg={4} >
          <DayRipetizioniBox />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={4}>
            <GeneralCustomDateTimePicker
              TypeTimePicker={5}
              label={t("Repeat_booking_until")}
              valueStart={valueDataFineRipetizioni}
              handleChange={handleChangeData}
              placeholder={t("Booking_date_placeholder")}
              minDate={minDayDate}
              maxDate={maxday}
              disabled={!ripetizioneStatus}
            />
        </Grid></>}
      </Grid>
    </React.Fragment>
  );
}
